import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Branch } from '../interfaces/branch';

@Injectable({
  providedIn: 'root'
})
export class BranchesService {

  constructor(private https: HttpClient) { }

  getBranchesHopping() {
    return this.https.get<Branch[]>(`${environment.apiUrl}branches/hopping`);
  }

  getBranchesByCategory(categoryId: number) {
    return this.https.get<Branch[]>(`${environment.apiUrl}branches/hopping/category/${categoryId}`);
  }

  getBranch(id: number) {
    return this.https.get<Branch>(`${environment.apiUrl}branches/${id}`);
  }

}

